/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import CSSModules from 'react-css-modules';
import { injectIntl, intlShape } from 'react-intl';
import Toolbar from 'loracoms/Toolbar';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Header from './coms/Header';
import GpsMap from './coms/GpsMap';
import styles from './styles.scss';

const propTypes = {
  intl: intlShape.isRequired,
};

class RoadTestView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.roadtest');
  }

  componentDidMount() {
    this.calMapHeight();
  }

  calMapHeight() {
    let timer = 0;
    let mapHeight;
    if (timer < 5 && !mapHeight) {
      if (this.container) {
        mapHeight = window.innerHeight - this.container.offsetHeight - 100;
        this.setState({ mapHeight });
      } else {
        timer += 1;
        setTimeout(() => {
          this.calMapHeight();
        }, 1000);
      }
    }
  }

  render() {
    const { mapHeight } = this.state;
    return (
      <div styleName="container" ref={(div) => { this.container = div; }} >
        <Toolbar
          brandTitle={this.intlMsg.msg('title')}
        />
        <Header />
        {mapHeight &&
          <div style={{ height: mapHeight }}>
            <GpsMap />
          </div>
        }
      </div>
    );
  }
}

RoadTestView.propTypes = propTypes;

export default injectIntl(CSSModules(RoadTestView, styles, { allowMultiple: true }));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/RoadTestView/index.jsx